(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(MB.locale || 'en', { style: 'currency', currency: MB.currency || 'AUD', currencyDisplay: 'narrowSymbol' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* Announcement rotation */
  $$('[data-announce]').forEach((bar) => {
    const msgs = $$('.announce__msg', bar);
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, parseInt(bar.dataset.speed || '4500', 10));
  });

  /* Fade up on scroll */
  const fades = $$('.fade-up');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    fades.forEach((el) => io.observe(el));
  } else fades.forEach((el) => el.classList.add('is-visible'));

  /* Mobile nav */
  const mnav = $('#MobileNav');
  const setNav = (open) => {
    if (!mnav) return;
    mnav.classList.toggle('is-open', open);
    mnav.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('no-scroll', open);
    $$('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
    if (open) { const f = $('a, button', mnav.querySelector('.mobile-nav__panel')); f && f.focus(); }
  };
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => setNav(true)));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => setNav(false)));

  /* Search bar */
  $$('[data-search-toggle]').forEach((b) => b.addEventListener('click', () => {
    const bar = $('#SearchBar');
    if (!bar) return;
    const open = !bar.classList.contains('is-open');
    bar.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', String(open));
    if (open) $('input', bar).focus();
  }));

  /* Currency selector */
  $$('select[name="country_code"]').forEach((s) => s.addEventListener('change', () => s.form.submit()));

  /* Quantity steppers (delegated) */
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const wrap = e.target.closest('[data-qty]');
    const input = $('input', wrap);
    const min = parseInt(input.min || '0', 10);
    const v = Math.max(min, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Gallery */
  $$('[data-product-card]').forEach((card) => {
    const main = $('[data-gallery-main] img', card);
    $$('[data-thumb]', card).forEach((t) => t.addEventListener('click', () => {
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = t.dataset.thumb;
      main.alt = t.dataset.alt;
      $$('[data-thumb]', card).forEach((x) => x.setAttribute('aria-current', String(x === t)));
    }));
    const sel = $('[data-variant-select]', card);
    if (sel) sel.addEventListener('change', () => {
      $('input[name="id"]', card).value = sel.value;
      const p = $('[data-price]', card);
      if (p) p.textContent = sel.selectedOptions[0].dataset.price;
    });
  });

  /* Gallery arrows + swipe */
  $$('[data-gallery]').forEach((g) => {
    const thumbs = $$('[data-thumb]', g);
    if (thumbs.length < 2) return;
    const current = () => Math.max(0, thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'));
    const go = (dir) => {
      const next = thumbs[(current() + dir + thumbs.length) % thumbs.length];
      next.click();
      const strip = next.parentElement;
      strip.scrollTo({ left: next.offsetLeft - strip.offsetLeft - (strip.clientWidth - next.clientWidth) / 2, behavior: 'smooth' });
    };
    const prev = $('[data-gallery-prev]', g); const nxt = $('[data-gallery-next]', g);
    prev && prev.addEventListener('click', () => go(-1));
    nxt && nxt.addEventListener('click', () => go(1));
    const main = $('[data-gallery-main]', g);
    let x0 = null;
    main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      x0 = null;
    });
  });

  /* Cart drawer */
  const drawer = $('#CartDrawer');
  let lastFocus = null;
  const openDrawer = () => {
    if (!drawer) return (window.location.href = MB.routes.cart);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const c = $('[data-drawer-close].icon-btn', drawer); c && c.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  document.addEventListener('click', (e) => { if (e.target.closest('[data-drawer-close]')) closeDrawer(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); setNav(false); } });
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); renderCart().then(openDrawer); }));

  const renderCart = async () => {
    const cart = await fetch(MB.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    if (!drawer) return cart;
    const body = $('[data-drawer-body]', drawer);
    const foot = $('[data-drawer-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = $('#CartEmptyTpl').innerHTML;
      foot.hidden = true;
      return cart;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map((it) => `
      <div class="line" data-key="${esc(it.key)}">
        ${it.image ? `<img src="${esc(it.image)}" alt="" width="76" height="76" loading="lazy">` : '<span></span>'}
        <div>
          <a class="line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="drawer__note">${esc(it.variant_title)}</div>` : ''}
          ${it.selling_plan_allocation ? `<div class="drawer__note">${esc(it.selling_plan_allocation.selling_plan.name)}</div>` : ''}
          ${(it.line_level_discount_allocations || []).map((d) => `<div class="drawer__note" style="color:var(--lav-700);font-weight:700">✦ ${esc(d.discount_application.title)}</div>`).join('')}
          <div class="qty" data-qty>
            <button type="button" data-qty-minus aria-label="Decrease quantity">−</button>
            <input type="number" min="0" value="${it.quantity}" aria-label="Quantity" data-line-qty>
            <button type="button" data-qty-plus aria-label="Increase quantity">+</button>
          </div>
          <button type="button" class="line__remove" data-line-remove>Remove</button>
        </div>
        <div class="line__price">${money(it.final_line_price)}</div>
      </div>`).join('');
    $('[data-drawer-total]', drawer).textContent = money(cart.total_price);
    return cart;
  };

  const changeLine = async (key, quantity) => {
    await fetch(MB.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    renderCart();
  };
  if (drawer) {
    drawer.addEventListener('change', (e) => {
      const input = e.target.closest('[data-line-qty]');
      if (!input) return;
      changeLine(input.closest('.line').dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
    });
    drawer.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-line-remove]');
      if (rm) changeLine(rm.closest('.line').dataset.key, 0);
    });
  }

  const addToCart = async (form) => {
    if (MB.prelaunch) return;
    const msg = $('[data-form-msg]', form);
    const btn = $('button[type="submit"]', form);
    const item = { id: Number($('input[name="id"]', form).value), quantity: parseInt($('[data-qty-input]', form).value, 10) || 1 };
    const plan = $('[data-plan-input]', form).value;
    if (plan) item.selling_plan = Number(plan);
    btn && (btn.disabled = true);
    msg && (msg.textContent = '');
    try {
      const res = await fetch(MB.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      await renderCart();
      openDrawer();
    } catch (err) {
      msg && (msg.textContent = err.message);
    } finally {
      btn && (btn.disabled = false);
    }
  };

  $$('[data-product-form]').forEach((form) => {
    const price = parseInt(form.dataset.price, 10);
    const pct = { 1: 0, 2: parseFloat(form.dataset.pct2) || 0, 3: parseFloat(form.dataset.pct3) || 0 };
    const qtyInput = $('[data-qty-input]', form);
    const planInput = $('[data-plan-input]', form);
    const bundles = $('[data-bundles]', form);
    const totalEl = $('[data-total]', form);
    const update = () => {
      const purchase = $('[data-purchase] input:checked', form);
      const isSub = purchase && purchase.value === 'sub';
      planInput.value = isSub ? purchase.dataset.plan : '';
      if (bundles) bundles.hidden = !!isSub;
      if (isSub) {
        qtyInput.value = 1;
        totalEl.textContent = money(parseInt(purchase.dataset.unit, 10));
        return;
      }
      const b = $('[data-bundles] input:checked', form);
      const qty = b ? parseInt(b.value, 10) : 1;
      qtyInput.value = qty;
      totalEl.textContent = money(Math.floor(price * qty * (100 - (pct[qty] || 0)) / 100));
    };
    form.addEventListener('change', update);
    update();
    form.addEventListener('submit', (e) => { e.preventDefault(); addToCart(form); });
  });


  /* Tracking number lookup */
  $$('[data-track-number]').forEach((form) => form.addEventListener('submit', (e) => {
    e.preventDefault();
    const n = $('input', form).value.trim();
    if (n) window.open('https://t.17track.net/en#nums=' + encodeURIComponent(n), '_blank', 'noopener');
  }));
})();
